import React from 'react';

export default function Check({ iconClass }: { iconClass?: string }) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="m553.9 146.5-14 19.5-264 368-16.5 23-20-20-136-136-17-17 33.9-33.9 17 17 116 116 247.5-345 14-19.5 39 28z" />
    </svg>
  )
}
